import { Skeleton } from '@ria-client/tw-shadcn/components/skeleton';
import { TableCell, TableRow } from '@ria-client/tw-shadcn/components/table';

export interface SkeletonRowProps {
  driversLength?: number;
}

const CELL_CLASS =
  'h-[200px] border-x-0 border-t-0 border-b border-border align-top md:h-[147px] [&:not(:first-child)]:border-l-0';

export function SkeletonRow({ driversLength = 0 }: SkeletonRowProps) {
  return (
    <TableRow data-testid="skeleton-row">
      <TableCell
        className={`${CELL_CLASS} relative w-[190px] bg-white py-3 pl-0 pr-2 md:min-w-[190px] ${driversLength ? 'md:w-[190px]' : 'md:w-auto'}`}
      >
        <Skeleton className="h-full" />
      </TableCell>
      <TableCell className={`${CELL_CLASS} min-w-[130px] w-[230px] px-2 py-3`}>
        <Skeleton className="h-full" />
      </TableCell>
      {Array.from({ length: driversLength }).map((_, index) => (
        <TableCell
          className={`${CELL_CLASS} w-[190px] min-w-[130px] overflow-hidden px-2 py-3`}
          key={index}
        >
          <Skeleton className="h-full" />
        </TableCell>
      ))}
      <TableCell className={`${CELL_CLASS} hidden w-[159px] px-2 py-3 md:table-cell`}>
        <Skeleton className="h-full" />
      </TableCell>
    </TableRow>
  );
}
